import React from "react";
import GoogleMapReact from "google-map-react";

const LoadMap = () => {
  const apiKey = process.env.REACT_APP_GOOGLE_KEY;

  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: apiKey,
        libraries: "drawing,places,geometry",
        v: "3.64",
      }}
      options={{
        gestureHandling: "greedy",
      }}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={({ map, maps }) => console.log(map, maps)}
    ></GoogleMapReact>
  );
};

export default LoadMap;
